/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

/**
 * Quagga Helpers
 */
const offsetY = 6;
const offsetX = 6;
let numOfWorkers = 1;
if (typeof navigator !== "undefined") {
    numOfWorkers = navigator.hardwareConcurrency / 2;
    numOfWorkers = numOfWorkers > 1 ? numOfWorkers : 1;
}

export const quaggaConfig: any = {
    inputStream: {
        type: "LiveStream",
        constraints: {
            facingMode: "environment",
        },
        target: "#barcode-scanner-live-stream",
        area: {
            // defines rectangle of the detection/localization area
            top: `${offsetY}%`, // top offset
            right: `${offsetX}%`, // right offset
            left: `${offsetX}%`, // left offset
            bottom: `${offsetY}%`, // bottom offset
        },
        singleChannel: false,
    },
    locator: {
        patchSize: "medium",
        halfSample: false,
    },
    numOfWorkers,
    frequency: 10,
    decoder: {
        readers: ["code_128_reader", "code_39_reader", "i2of5_reader", "upc_reader"],
    },
    locate: true,
};

export function drawBoundaries(drawingCtx: CanvasRenderingContext2D, ctxWidth: number, ctxHeight: number) {
    const oldStrokeStyle = drawingCtx.strokeStyle;
    drawingCtx.strokeStyle = "#399A5D";
    drawingCtx.setLineDash([10, 5]);
    drawingCtx.beginPath();
    const tmpOffsetX = offsetX * 2;
    const tmpOffsetY = offsetY * 2;
    drawingCtx.rect(
        (ctxWidth * tmpOffsetX) / 100,
        (ctxHeight * tmpOffsetY) / 100,
        (ctxWidth * (100 - tmpOffsetX * 2)) / 100,
        (ctxHeight * (100 - tmpOffsetY * 2)) / 100,
    );
    drawingCtx.stroke();
    drawingCtx.strokeStyle = oldStrokeStyle;
    drawingCtx.setLineDash([1, 0]);
}

export function drawOverlay(drawingCtx: CanvasRenderingContext2D, width: number, height: number, points: any[]) {
    const oldAlpha = drawingCtx.globalAlpha;
    const oldFillStyle = drawingCtx.fillStyle;
    const oldGlobalCompositeOperation = drawingCtx.globalCompositeOperation;
    drawingCtx.globalAlpha = 0.3;
    drawingCtx.fillStyle = "rgba(0, 0, 0, 1)";
    drawingCtx.fillRect(0, 0, width, height);
    drawingCtx.globalAlpha = oldAlpha;
    drawingCtx.globalCompositeOperation = "destination-out";

    drawingCtx.fillStyle = "#DC3545";
    drawingCtx.beginPath();
    drawingCtx.moveTo(points[0][0] - (offsetX * width) / 100, points[0][1] - (offsetY * height) / 100);
    for (let i = 1; i < points.length; i++) {
        drawingCtx.lineTo(points[i][0] - (offsetX * width) / 100, points[i][1] - (offsetY * height) / 100);
    }
    drawingCtx.closePath();
    drawingCtx.fill();
    // Quagga.ImageDebug.drawRect(result.box, { x: 0, y: 1 }, drawingCtx, { color: "#00F", lineWidth: 2 });
    drawingCtx.globalCompositeOperation = oldGlobalCompositeOperation;
    drawingCtx.fillStyle = oldFillStyle;
}

export function generateImageThumbnail(canvas: any, points: any[], ctxWidth: number, ctxHeight: number): string {
    let minY = Infinity;
    let minX = Infinity;
    let maxY = 0;
    let maxX = 0;

    // find image boundries (x, y and width & height)
    for (let i = 0; i < points.length; i++) {
        if (points[i][0] < minX) {
            minX = points[i][0];
        }
        if (points[i][0] > maxX) {
            maxX = points[i][0];
        }
        if (points[i][1] < minY) {
            minY = points[i][1];
        }
        if (points[i][1] > maxY) {
            maxY = points[i][1];
        }
    }

    const width = maxX - minX;
    const height = maxY - minY;

    const thumbCanvas = document.createElement("canvas");
    thumbCanvas.width = width;
    thumbCanvas.height = height;
    const ctx = thumbCanvas.getContext("2d");
    ctx &&
        ctx.drawImage(
            canvas,
            minX - (offsetX * ctxWidth) / 100,
            minY - (offsetY * ctxHeight) / 100,
            width,
            height,
            0,
            0,
            width,
            height,
        );
    return thumbCanvas.toDataURL();
}
